import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { useComparator } from "@tudigo-monorepo/web-tudigo-comparator";
import { Skeleton } from "@tudigo-monorepo/web-tudigo-components";

import { ProjectMechanicSettingsCard } from "../../../../shared-internal/components/project-mechanic-settings-card";
import {
  ProjectCard,
  ProjectCardAvatar,
  ProjectCardAvatarFallback,
  ProjectCardBadges,
  ProjectCardContent,
  ProjectCardDescription,
  ProjectCardHeader,
  ProjectCardLabel,
} from "./../../../../../shared-external/components/project-card/project-card";

export function ProjectsComparatorProjectCard({
  project,
}: {
  project: Project;
}) {
  const { isLoading } = useComparator();

  return (
    <ProjectCard project={project} className="h-auto bg-transparent">
      <ProjectCardContent className="justify-normal border-none p-0">
        <ProjectCardHeader className="mb-0 w-full rounded-b-lg py-2">
          <ProjectCardAvatar />
          <ProjectCardAvatarFallback />
          <ProjectCardLabel className="max-w-52 truncate text-base font-medium" />
        </ProjectCardHeader>
        {isLoading ? (
          <>
            <div className="mb-4 flex h-[25px] flex-wrap items-center gap-2">
              <Skeleton className="h-full w-16" />
              <Skeleton className="h-full w-20" />
              <Skeleton className="h-full w-8" />
            </div>
            <Skeleton className="mb-4 h-14 w-full" />
            <Skeleton className="h-28 w-full" />
          </>
        ) : (
          <>
            <ProjectCardBadges className="mt-2" />
            <ProjectCardDescription />
            <ProjectMechanicSettingsCard
              project={project}
              className="mb-0 min-h-[111px]"
            />
          </>
        )}
      </ProjectCardContent>
    </ProjectCard>
  );
}
